import React, { useEffect, useState } from 'react';

import { clearAllLogs, useDebugLogsForRequest, useDebugLogsRequestsList } from 'src/services/debugLogs';

import ListOfRequests from './ListOfRequests';
import Status from './Status';
import ViewLogs from './ViewLogs';

import './debug-log.css';

const TopBar = () => {
  return (
    <div style={{ marginBottom: 10 }}>
      <Status/>
    </div>
  );
};

const DebugLogs = () => {
  const [currentRequestId, setCurrentRequestId] = useState(null);
  let requests = useDebugLogsRequestsList();
  const logs = useDebugLogsForRequest(currentRequestId);

  useEffect(() => {
    if (currentRequestId === null && requests[0] && requests[0].request_id) {
      setCurrentRequestId(requests[0].request_id);
    }
  }, [currentRequestId, requests]);


  return (
    <div data-cy="top-level-debug-logs" className="top-level-debug-logs">
      <TopBar/>
      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ width: '20%' }}>
          <ListOfRequests
            requests={requests}
            setCurrentRequestId={setCurrentRequestId}
            currentRequestId={currentRequestId}
            clearAllLogs={clearAllLogs}
          />
        </div>
        <div style={{ width: 1, backgroundColor: 'gray', margin: '0 5px 0 5px' }}/>
        <div style={{ width: '80%' }}><ViewLogs logs={logs}/></div>
      </div>
    </div>
  );
};

export default DebugLogs;
